export const vehicleColumns = [
  {
    field: 'facilityName',
    headerName: 'Facility',
    minWidth: 100,
    flex: 1,
    renderCell: (params) => params.value,
  },
  {
    field: 'vin',
    headerName: 'VIN',
    minWidth: 140,
    flex: 1,
    renderCell: (params) => params.value,
  },
  {
    field: 'make',
    headerName: 'Make',
    minWidth: 110,
    flex: 1,
    renderCell: (params) => params.value,
  },
  {
    field: 'model',
    headerName: 'Model',
    minWidth: 110,
    flex: 1,
    renderCell: (params) => params.value,
  },
  {
    field: 'year',
    headerName: 'Year',
    minWidth: 90,
    flex: 1,
    renderCell: (params) => params.value,
  },
  {
    field: 'licensePlate',
    headerName: 'License Plate',
    minWidth: 120,
    flex: 1,
    renderCell: (params) => params.value,
  },
  {
    field: 'registrationExpiresAt',
    headerName: 'Registration Expiration',
    minWidth: 160,
    flex: 1,
    renderCell: (params) => (params.value ? new Date(params.value).toLocaleDateString() : ''),
  },
  {
    field: 'ownershipStatus',
    headerName: 'Ownership Status',
    minWidth: 130,
    flex: 1,
    renderCell: (params) => params.value,
  },
];
